import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import {
  CardModalView,
  ViewBody
} from 'components/Sidebar'
import {
  FormGroup,
  FormControl,
  ButtonGroup
} from 'react-bootstrap'
import Button from 'components/Button'
import Info from 'components/Info'
import Loader from 'components/Loader'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import AddAddress from './AddAddress'
import EditAddress from './EditAddress'
import { ModalCardContext } from 'components/Modal'
import KanBoIcon from 'components/KanBoIcon'
import Alert from 'components/Alert'
import styled from 'styled-components'

const NoEmailAlert = styled(Alert)`
  margin-top: 10px;
`

export class IncomingEmails extends React.Component {
  static propTypes = {
    cardId: PropTypes.number.isRequired,

    intl: PropTypes.object.isRequired,

    cardContext: PropTypes.object.isRequired,

    incomingMailsDomain: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isLoaded: PropTypes.bool.isRequired,
    publicIncomingMailName: PropTypes.string,
    publicIncomingMailValidateAddress: PropTypes.bool,

    fetchIncomingMails: PropTypes.func.isRequired,
    requestAddIncomingMail: PropTypes.func.isRequired,
    requestRemoveIncomingMail: PropTypes.func.isRequired
  }

  componentDidMount () {
    this.tryFetchIncomingMails()
  }

  componentDidUpdate () {
    this.tryFetchIncomingMails()
  }

  tryFetchIncomingMails = () => {
    const {
      cardContext,
      isLoading,
      isLoaded,
      fetchIncomingMails
    } = this.props

    if (!isLoading && !isLoaded) {
      fetchIncomingMails({
        cardId: cardContext.id
      })
    }
  }

  handleRemovePublicAddress = () => {
    this.props.requestRemoveIncomingMail({
      name: this.props.publicIncomingMailName
    })
  }

  handleCreatePublicAddressClick = () => {
    const {
      leftSidebar,
      cardId,
    } = this.props

    leftSidebar.push((props) => <ModalCardContext cardId={cardId}><AddAddress {...props} cardId={cardId} /></ModalCardContext>)
  }

  handleEditPublicAddressClick = () => {
    const {
      leftSidebar,
      cardId,
      publicIncomingMailName,
    } = this.props

    leftSidebar.push((props) => <ModalCardContext cardId={cardId}><EditAddress {...props} cardId={cardId} name={publicIncomingMailName} /></ModalCardContext>)
  }

  render () {
    const {
      incomingMailsDomain,
      isLoaded,
      publicIncomingMailName,
      publicIncomingMailValidateAddress,
    } = this.props

    return (
      <CardModalView
        title={
          <>
            <FormattedMessage id='INCOMING_EMAILS' />
            <Info className='m-l-10'>
              <FormattedMessage id='INCOMING_EMAILS_CARD_ADDRESS_DESCRIPTION' />
            </Info>
          </>
        }
      >
        <ViewBody>
          {!isLoaded ? (
            <Loader center />
          ) : (
            <FormGroup>
              {publicIncomingMailName &&
                <FormControl
                  readOnly
                  type='text'
                  className='m-b-10'
                  value={publicIncomingMailName + '@' + incomingMailsDomain}
                />
              }
              {publicIncomingMailValidateAddress &&
                <p>
                  <FormattedMessage id='INCOMING_EMAILS_VALIDATE_ADDRESS_OPTION' />
                </p>
              }
              <div>
                {publicIncomingMailName ? (
                  <ButtonGroup>
                    <Button
                      onClick={this.handleEditPublicAddressClick}
                    >
                      <FormattedMessage id='INCOMING_EMAILS_EDIT' />
                    </Button>
                    <Button
                      onClick={this.handleRemovePublicAddress}
                    >
                      <FormattedMessage id='REMOVE' />
                    </Button>
                  </ButtonGroup>
                ) : (
                  <Button
                    icon={<KanBoIcon name='kanbo-16-plus' />}
                    onClick={this.handleCreatePublicAddressClick}
                  >
                    <FormattedMessage id='ADD' />
                  </Button>
                )}
              </div>
              {!publicIncomingMailName &&
                <NoEmailAlert>
                  <FormattedMessage id='INCOMING_EMAILS_CARD_ADDRESS_NOT_CREATED' />
                </NoEmailAlert>
              }
            </FormGroup>
          )}
        </ViewBody>
      </CardModalView>
    )
  }
}

export default withLeftSidebar(injectIntl(IncomingEmails))
